import { AiScrubScope } from '../../models';

export const aiScrubStreamUrl = (baseUrl: string, awardId: number, batchRunId: string, token: string, scope: AiScrubScope = 'awards'): string =>
  `${baseUrl}/api/staff/${scope}/${awardId}/ai-scrub-batch/${encodeURIComponent(batchRunId)}/stream?token=${encodeURIComponent(token)}`;
